// React import removed - not needed in React 17+
import { BrowserRouter as Router } from 'react-router-dom';
import { QueryClientProvider } from './core/query/QueryClientProvider';
import { AuthProvider } from './core/auth/AuthContext';
import { ErrorBoundary } from './components/ui/error-boundary';
import { ToastProvider } from './core/notifications/ToastContext';
import { ConfirmProvider } from './core/notifications/ConfirmContext';
import { ThemeProvider } from './core/theme/ThemeContext';
import ToastContainer from './core/notifications/ToastContainer';
import Routes from './Routes';

/**
 * Root application component that sets up the providers for:
 * - Error Boundary
 * - Theme (outside router/auth so auth screens follow the theme too)
 * - React Router
 * - React Query
 * - Authentication
 * - UI State
 * - Feature Flags/Config
 */
function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider>
        <Router
          future={{
            v7_startTransition: true,
            v7_relativeSplatPath: true,
          }}
        >
          <QueryClientProvider>
            <AuthProvider>
              <ToastProvider>
                <ConfirmProvider>
                  <ToastContainer />
                  <Routes />
                </ConfirmProvider>
              </ToastProvider>
            </AuthProvider>
          </QueryClientProvider>
        </Router>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
